<template lang="pug">
  SingleLayout(
    :item='true'
    :itemlist='true'
    :showcases='["artist", "releated"]'
  )
    template(
      slot='item'
      v-if='album'
    )
      Album(
        type='full'
        :key='albumId'
        :album='album'
      )
    template(
      slot='itemlist'
      v-if='album'
    )
      ItemList(
        type='tracks'
        view='list'
        :empty-message='$l10n("DONT_HAVE_TRACKS")'
        :key='albumId'
        :tracklist='tracklist'
        :items='albumTracks'
      )
    template(
      slot='showcase-artist'
      v-if='albumsByArtist.length && !isReview'
    )
      Showcase(
        type='albums'
        :title='$l10n("ALBUMS_SAME_ARTIST")'
        :key='albumId'
        :url='`/artists/${artistId}/albums`'
        :items='albumsByArtist'
      )
    template(
      slot='showcase-releated'
      v-if='releatedAlbums.length && !isReview'
    )
      Showcase(
        type='albums'
        :title='$l10n("RELEATED_ALBUMS")'
        :key='albumId'
        :url='`/albums/${albumId}/releated`'
        :items='releatedAlbums'
      )
</template>

<script>
import singlePage from "@/mixins/pages/single.mixin";
import PageLoader from "@/services/pageLoader";
import Showcase from "@/components/Showcase/Showcase";
import Album from "@/components/Album/Album";
import ItemList from "@/components/ItemList/ItemList";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";
import { ITEMS_IN_SHOWCASE } from "@/constants";

const strategy = async function(route, ctx) {
  ctx.albumType = route.meta.type;

  const isReview = ctx.albumType === "review";

  try {
    const id = PageLoader.getIdFromRoute(route);
    const { album = {} } = await PageLoader[
      isReview ? "getReviewAlbum" : "getAlbum"
    ]({ id });

    ctx._album = album;
    ctx.albumId = id;

    route.meta.title = album.title;
  } catch (error) {
    errorHandler.resolve(error);

    return;
  }

  try {
    await PageLoader[isReview ? "getReviewTracks" : "getTracks"]({
      ids: ctx._album.tracks
    });
  } catch (error) {
    errorHandler.add(error);
  }

  if (!isReview) {
    try {
      const {
        albums: releatedAlbums = []
      } = await PageLoader.getReleatedAlbums({
        id: ctx.albumId
      });

      ctx.releatedAlbumsIds = releatedAlbums
        .map(album => album.id)
        .filter(id => id !== ctx._album.id);
    } catch (error) {
      errorHandler.add(error);
    }

    try {
      const artistId = PageLoader.getFirstArtist(ctx._album);

      const { albums: albumsByArtist } = await PageLoader.getAlbumsByArtist({
        id: artistId
      });

      ctx.artistId = artistId;
      ctx.albumsByArtistIds = albumsByArtist
        .map(album => album.id)
        .filter(id => id !== ctx._album.id);
    } catch (error) {
      errorHandler.add(error);
    }
  }
};

export default {
  name: "AlbumPage",
  mixins: [singlePage(strategy)],
  data() {
    return {
      albumType: "default",
      albumId: null,
      artistId: null,
      albumsByArtistIds: [],
      releatedAlbumsIds: []
    };
  },
  computed: {
    ...mapGetters({
      albums: "albums/albums",
      tracks: "tracks/tracks"
    }),
    album() {
      return this.albums[this.albumId];
    },
    albumTracks() {
      return this.album.tracks.map(id => this.tracks[id]);
    },
    albumsByArtist() {
      return this.albumsByArtistIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map(id => this.albums[id]);
    },
    releatedAlbums() {
      return this.releatedAlbumsIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map(id => this.albums[id]);
    },
    tracklist() {
      return {
        id: this.albumId,
        tracks: this.album.tracks
      };
    },
    isReview() {
      return this.albumType === "review";
    }
  },
  components: {
    Album,
    ItemList,
    Showcase
  }
};
</script>
